import { status } from "skin/event/status";

export default function loyalty(obj, ms, story, data, d, action) {
	return status.action;
}
